



















































import { Component, Prop, Vue } from 'vue-property-decorator';
import {
    IAllocation,
    IAllocationSearchParameters,
    IWeekAllocations,
} from '@/interfaces/allocation';
import AllocationCard from '@/components/allocations/allocation-card.vue';

@Component({
    components: {
        AllocationCard,
    },
})
export default class ResultsPanel extends Vue {
    @Prop({ required: true }) private readonly allocations!: IAllocation[];
    @Prop({ required: true })
    @Prop() refreshDate!: string;
    @Prop() weekOffset: any;
    private readonly parameters!: IAllocationSearchParameters;

    private selectedWeekOffset: number = 0;

    get weeklyAllocations(): IWeekAllocations[] {
        const weeklyAllocations = [] as IWeekAllocations[];

        if (this.allocations) {
            //const selectedWeekDate = startOfWeek(this.parameters.departureDate);
            // TODO: define week to display rule
            // "-1, 0, 1" offset from departure date week
            [-1, 0, 1].forEach((weekOffset) => {
                const startWeekDate = new Date(0);
                //startWeekDate.setDate(startWeekDate.getDate() + 7 * weekOffset);

                const endWeekDate = new Date(0);
                //endWeekDate.setDate(endWeekDate.getDate() + 7);

                const weekAllocations: IWeekAllocations = {
                    weekOffset,
                    startWeekDate,
                    endWeekDate,
                    allocations: this.allocations.filter(
                        (allocation) =>
                            allocation.weekOffset === weekOffset
                    ),
                };
                weeklyAllocations.push(weekAllocations);
            });
        }
        return weeklyAllocations;
    }

    isSelectedWeekOffset(weekNumberOffset: number) {
        if (weekNumberOffset == -1)
            return this.weekOffset.previousWeek;
        if (weekNumberOffset == 0)
            return this.weekOffset.currentWeek;
        if (weekNumberOffset == 1)
            return this.weekOffset.nextWeek;
    }

    getWeekOffsetText(weekOffset: number) {
        const weekOffsetMessage = this.$t(
            'allocations.results-panel.week-offset'
        ) as string;

        if (weekOffset === 0) {
            return weekOffsetMessage;
        } else if (weekOffset < 0) {
            return weekOffsetMessage + ' ' + weekOffset;
        } else if (weekOffset > 0) {
            return weekOffsetMessage + ' + ' + weekOffset;
        }
        return '';
    }
    selectWeekOffset(weekOffset: number) {
        this.selectedWeekOffset = weekOffset;
    }
    exportClick() {
        this.$emit('export-allocations');
    }
    copyReference(reference: string) {
        this.$emit('copy-allocation-reference', reference);
    }
    toggleSubcardDisplay(weekNumberOffset: number) {
        if (weekNumberOffset == -1)
            this.weekOffset.previousWeek = !this.weekOffset.previousWeek;
        if (weekNumberOffset == 0)
            this.weekOffset.currentWeek = !this.weekOffset.currentWeek;
        if (weekNumberOffset == 1)
            this.weekOffset.nextWeek = !this.weekOffset.nextWeek;
    }
}
